import { render, staticRenderFns } from "./BullQuaratineTwo.vue?vue&type=template&id=37ff349f&scoped=true&"
import script from "./BullQuaratineTwo.vue?vue&type=script&lang=js&"
export * from "./BullQuaratineTwo.vue?vue&type=script&lang=js&"
import style0 from "./BullQuaratineTwo.vue?vue&type=style&index=0&id=37ff349f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ff349f",
  null
  
)

export default component.exports